import PropTypes from "prop-types";
import _get from "lodash/get";
import React from "react";
import { FieldLabel, RemoteSelectField } from "react-invenio-forms";
import { i18next } from "@translations/up/i18next";
import { Field, getIn } from "formik";

const serializeSuggestions = (suggestions) => {
  return suggestions.map((item) => ({
    text: item.name ?? item.id,
    value: item.id ?? item.name,
    key: item.id ?? item.name,
    ...(item.id ? { id: item.id } : {}),
    name: item.name ?? item.id,
  }));
};

export const UniversityField = ({ fieldPath, record }) => {
  return (
    <Field name={fieldPath}>
      {({ form: { values } }) => (
        <RemoteSelectField
          fieldPath={fieldPath}
          suggestionAPIUrl="/api/affiliations"
          suggestionAPIHeaders={{
            Accept: "application/vnd.inveniordm.v1+json",
          }}
          initialSuggestions={_get(
            record,
            "ui.custom_fields.ubiquity:thesis.university",
            []
          ).filter((uni) => uni && Object.keys(uni).length > 0)}
          onValueChange={({ formikProps }, selectedSuggestions) => {
            formikProps.form.setFieldValue(
              fieldPath,
              selectedSuggestions.map((uni) => ({
                name: uni.name,
                id: uni.id,
              }))
            );
          }}
          serializeSuggestions={serializeSuggestions}
          serializeAddedValue={(value) => ({
            text: value,
            value: value,
            key: value,
            name: value,
          })}
          value={getIn(values, fieldPath, []).map((val) => val.id ?? val.name)}
          placeholder={i18next.t("Search or create university")}
          label={
            <FieldLabel htmlFor={`${fieldPath}.name`} label={i18next.t("University")} />
          }
          noQueryMessage={i18next.t("Search for universities..")}
          multiple
          clearable
          allowAdditions
        />
      )}
    </Field>
  );
};

UniversityField.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  record: PropTypes.object,
};

UniversityField.defaultProps = {
  record: {},
};
